module.exports = __webpack_public_path__ + "static/posterLogos-bcfe62a51919b7ad7126ad2388266ab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/posterLogos.jpg
// module id = 1093
// module chunks = 168707334958949